export const statuses = ["draft", "review", "approved", "archived"];

export const statusesAccessibleForClient = ["draft", "review"];

export const statusesCanChangeAdmin = ["review", "approved", "archived"];
